import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPercussion = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M16.38,7.635c-1.464-1.489-2.688-3.05-3.433-4.418c-0.529-0.961-0.721-1.657-0.745-2.185l-1.439,1.439 C9.85,3.385,9.346,4.61,9.346,5.906l0,0c0,2.544-1.009,4.993-2.81,6.794c-0.36,0.36-0.721,0.672-1.128,0.96L0.222,17.43 c-0.024,0.023-0.072,0.047-0.096,0.071c-0.504,0.504,0.553,2.376,2.282,4.107c1.729,1.727,3.601,2.784,4.129,2.256 c0.024-0.025,0.048-0.048,0.072-0.097l3.794-5.186c0.288-0.408,0.6-0.768,0.96-1.128l0,0c1.801-1.801,4.25-2.809,6.795-2.809l0,0 c1.271,0,2.521-0.505,3.433-1.417l1.44-1.44C21.448,11.74,18.878,10.108,16.38,7.635z"
	}), /* @__PURE__ */ _jsx("ellipse", {
		fill: "currentColor",
		transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 27.3753 22.6023)",
		cx: 18.369,
		cy: 5.631,
		rx: 7.635,
		ry: 2.258
	})]
});
export default SvgPercussion;
